// -----------------------------------------------------------
// 型ガード関数 (isScaledMapData) の定義
// -----------------------------------------------------------

import { GeoJSONFeature } from "maplibre-gl";
import { ScaledMapData } from "./type";

interface SerializedGeoJson {
  type: string;
  features: GeoJSONFeature[];
}

function isGeoJson(obj: unknown): obj is SerializedGeoJson {
  if (typeof obj !== "object" || obj === null) {
    return false;
  }
  const data = obj as Record<string, unknown>;

  // GeoJSONの最低限のチェック：オブジェクトであり、'type'と'features'プロパティを持つ
  return (
    // 'type' プロパティが文字列であるか
    typeof data.type === "string" &&
    // 'features' プロパティが配列であるか
    Array.isArray(data.features)
  );
}

export function isScaledMapData(obj: unknown): obj is ScaledMapData {
  if (typeof obj !== "object" || obj === null) {
    return false;
  }

  // 必須プロパティと、それらがGeoJSON構造（またはJSON互換構造）であることをチェック
  const data = obj as Partial<ScaledMapData>;

  return (
    data.scaledPolygons !== undefined &&
    isGeoJson(data.scaledPolygons) &&
    data.scaledIconsGeoJSON !== undefined &&
    isGeoJson(data.scaledIconsGeoJSON) &&
    data.doorGapFeatures !== undefined &&
    isGeoJson(data.doorGapFeatures)
  );
}
